var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fullscreen" },
    [
      !_vm.$isFullscreen
        ? _c("font-awesome-icon", {
            attrs: {
              icon: "expand-arrows-alt",
              title: "menu",
              "aria-hidden": "true",
            },
          })
        : _c("font-awesome-icon", {
            attrs: {
              icon: "compress-arrows-alt",
              title: "menu",
              "aria-hidden": "true",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }